export const LOAD_USER = "LOAD_USER";
export const USER_SIGN_OUT = "USER_SIGN_OUT";
export const USER_STATE_SAVE = "USER_STATE_SAVE";
